import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BaseWinnerListComponent from '@/components/game/implementations/_base/_components/winner-list';
import JackpotComponent from '@/components/game/implementations/_default/_components/jackpot';
import { IGameRepresentationChangedArgs, IGameStageWinnerSet } from '@/components/game/_domain/models';
import { IHexGameRepresentation } from '../../_domain/controller/game-controller';
import { getPrizeTypeName, HexPrizeType } from '../../_domain/models';

@Component({
  name: 'HexWinnerListComponent',
  components: {
    jackpot: JackpotComponent
  }
})
export default class HexWinnerListComponent extends BaseWinnerListComponent {
  private lastCalledColour: string = '';

  private get filteredWinners(): IGameStageWinnerSet[] {
    const winners = this.gameWinnerInfo.filter((gameWinner) => gameWinner.prizeName !== getPrizeTypeName(HexPrizeType.Stakeback));

    return winners ? winners : [];
  }

  private get stakebackWinnersCount(): number {
    const stakeback = this.gameWinnerInfo.find((gameWinner) => gameWinner.prizeName === getPrizeTypeName(HexPrizeType.Stakeback));

    return stakeback && stakeback.winners ? stakeback.winners.length : 0;
  }

  private mounted() {
    const game = this.gameController.getGame();
    this.updateWinnerListVisibility(game.state);

    Vue.nextTick(() => {
      this.gameController
        .onGameStateChanged(this.handleGameStateChanged)
        .onGameWon(this.handleGameWon)
        .onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }


  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation: IHexGameRepresentation = eventArgs.currentGameRepresentation;
    this.lastCalledColour = gameRepresentation.colours[gameRepresentation.colours.length - 1];
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/hex/_components/winner-list/winner-list.component.ts